/**
 * Canonical presentation statuses used by every status-tinted UI
 * element (pills, badges, table rows). Concrete domain enums
 * (OrderStatus, ProductionAssignmentStatus, ShipmentStatus) are
 * mapped onto these buckets by the page that renders them — the
 * shared components only know the five visual states below.
 *
 * Each entry is paired with a `--status-*` CSS custom property
 * declared in the two theme sheets, so the same enum value
 * always resolves to a theme-appropriate colour.
 */
export const Status = {
  New: 'new',
  Progress: 'progress',
  Ready: 'ready',
  Blocked: 'blocked',
  Overdue: 'overdue',
} as const;

export type Status = (typeof Status)[keyof typeof Status];

export const ALL_STATUSES: readonly Status[] = [
  Status.New,
  Status.Progress,
  Status.Ready,
  Status.Blocked,
  Status.Overdue,
];

export const STATUS_LABELS: Readonly<Record<Status, string>> = {
  [Status.New]: 'New',
  [Status.Progress]: 'In progress',
  [Status.Ready]: 'Ready',
  [Status.Blocked]: 'Blocked',
  [Status.Overdue]: 'Overdue',
};
